import { apiClient } from '@/core/infra_api_client'
import type { ManagedChatAddressLevel } from './infra_managed_chat_rollout.service'
import type { MissionStackRolloutLevel } from './infra_mission_stack_rollout.service'
import type { UIVariantRolloutLevel } from './infra_ui_variant_rollout.service'

/**
 * Staff organisation list for cross-organisation rollout administration
 * (PLAN-20260930 slice 5): GET /v1/infra/staff/rollout/organizations, the
 * infra-service staff entry that forwards to governance (agion/Agion#3154),
 * served behind the verified platform administrator check. The server bounds the list
 * and reports with `more` whether further organisations exist.
 */
export interface StaffRolloutLevel<L extends string> {
  level: L
  revision: number
}

export interface StaffRolloutOrganization {
  id: string
  name: string
  uiVariant: StaffRolloutLevel<UIVariantRolloutLevel>
  missionStack: StaffRolloutLevel<MissionStackRolloutLevel>
  /** The Agion-managed chat address card's switch (PLAN-20261015 slice 15). */
  managedChatAddress: StaffRolloutLevel<ManagedChatAddressLevel>
}

export interface StaffRolloutOrganizationList {
  organizations: StaffRolloutOrganization[]
  more: boolean
  maxRows: number
}

export async function listStaffRolloutOrganizations(): Promise<StaffRolloutOrganizationList> {
  const response = await apiClient.get<StaffRolloutOrganizationList>('staff/rollout/organizations')
  return {
    organizations: response.organizations ?? [],
    more: response.more === true,
    maxRows: response.maxRows,
  }
}
